import { Component } from "react";
import { 
  Box,
  CircularProgress,
  Dialog,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Tab,
  Tabs,} from "@mui/material";
import { getAreaHistory } from '../../services/area';
import { isStaff } from "../../services/login";
import CustomChart from "./charts/CustomChart";
import DownloadContent  from './DownloadContent'

const STYLE_MAPPING = {
  '3 SD': {borderColor:'#2134FF', borderDash:[5, 5]},
  '2 SD': {borderColor:'#38CAFF', borderDash:[5, 5]},
  '1 SD': {borderColor:'#88FFDF', borderDash:[5, 5]},
  'Center': {borderColor:'#37ae00', borderDash:[5, 5]},
  '-1 SD': {borderColor:'#b3b152', borderDash:[5, 5]},
  '-2 SD': {borderColor:'#9e6400', borderDash:[5, 5]},
  '-3 SD': {borderColor:'#c50000', borderDash:[5, 5]},
}

class MapDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      isLoading: false,
      selectedDataTab: 1,
      selectedPredictTypeTab: 'daily',
      data: null,
      selectedArea: null,
      selectedData: null,
      isStaff: false
    }
  }

  async componentDidMount() {
    await this.fetchData()
    await this.setChartData()
    await this.checkLogin()

  }

  async checkLogin() {
    let _isStaff = await isStaff()
    await this.setState({isStaff:_isStaff})
  }
  
  async fetchData() {
    await this.setIsLoading(true)
    // console.log('MapDialog fetchData: ', this.state.selectedPredictTypeTab)
    let data = await getAreaHistory(
        this.state.selectedPredictTypeTab,
        this.props.selectedArea.tambon,
        this.props.selectedArea.amphoe,
        this.props.selectedArea.province
    )
    await this.setState({data})
    await this.setChartData()
    await this.setIsLoading(false)
  }

  onCloseModal = async () => {
    this.props.onCloseModal()
  }

  setChartData = async() => {
    let dataset = { 
      labels: this.state.data.label, 
      datasets: [{                    
        fill: true,
        borderColor: "#1976D2",
        backgroundColor: "rgba(64, 156, 236, 0.43)",
      }],
    }
    if(this.state.selectedDataTab === 1) {
      // let isStaff = this.state.isStaff
      
      if(this.state.data.wl.data.length === 9) {
        await this.checkLogin()
        if(this.state.isStaff) {
          dataset.labels = this.state.data.wl.labels
          dataset.datasets = this.state.data.wl.data
        } else {
          dataset.labels = this.state.data.wl.labels
          dataset.datasets = [this.state.data.wl.data[7], this.state.data.wl.data[8]]
        }
      } else {
        dataset.labels = this.state.data.wl.labels
        dataset.datasets = [this.state.data.wl.data[0], this.state.data.wl.data[1]]
      }
    } else if(this.state.selectedDataTab === 2) {
      dataset.labels = this.state.data.rain.labels
      dataset.datasets = [this.state.data.rain.data[0], this.state.data.rain.data[1]]

    } else if(this.state.selectedDataTab === 3) {
      dataset.labels = this.state.data.soil1.labels
      dataset.datasets = [this.state.data.soil1.data[0], this.state.data.soil1.data[1]]

    }  else if(this.state.selectedDataTab === 5) {
      dataset.labels = this.state.data.temperature.labels
      dataset.datasets = [this.state.data.temperature.data[0], this.state.data.temperature.data[1]]
    }


    dataset.datasets.forEach(d => {
      if(d.label.startsWith("ค่าพยากรณ์")) {
        if(this.state.isStaff && this.state.selectedDataTab === 1) {
          d.type = "line"
          d.borderColor = '#960000'
        } else {
          d.type = "bar"
          d.backgroundColor = "#ed6565"
        }

      } else {
        d.type = 'line'
        if(d.label in STYLE_MAPPING) {
          d.borderColor = STYLE_MAPPING[d.label].borderColor
          d.borderDash = STYLE_MAPPING[d.label].borderDash
        } else {
          d.borderColor = "#000f96"
        }
      }
    });

    await this.setState({
      selectedData: dataset
    })
  }

  setIsLoading = async (val) => {
    await this.setState({isLoading: val})
  }

  handleDataTabChange = async (e, value) => {
    await this.setIsLoading(true)
    await this.setState({
      selectedDataTab:value, 
    })
    await this.setChartData()
    await this.setIsLoading(false)
  }

  handlePredictTypeTabChange = async(e, value) => {
    await this.setIsLoading(true)
    await this.setState({
      selectedPredictTypeTab: value,
    })
    await this.fetchData();
    await this.setChartData();
    await this.setIsLoading(false)
  }

  transLevelToMessage(level) {
    const levelMapper = {
      0: "ไม่พบข้อมูล",
      1: "ระดับนํ้าน้อยมาก",
      2: "ระดับนํ้าน้อย",
      3: "ระดับนํ้าปกติ",
      4: "ระดับนํ้ามาก",
      5: "ระดับนํ้าสูงมาก",
    }
    return levelMapper[level]
  }

  render() {
    let options = {
      responsive: true,
      plugins: {
        tooltip: {
          mode: 'index',
          position: 'average',
        }
      },

      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
      },
    }
    let tabPredictType = [
      {value: 'daily', label: 'รายวัน'}, 
      {value: 'weekly', label: 'รายสัปดาห์'},
      {value: 'monthly', label: 'รายเดือน'},
      {value: 'yearly', label: 'รายปี'},
    ]
    return (
      <Grid>
        <Dialog 
          open={this.props.isModalOpen} 
          onClose={this.props.onCloseModal}   
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle>ต.{this.props.selectedArea.tambon} อ.{this.props.selectedArea.amphoe} จ.{this.props.selectedArea.province}</DialogTitle>
          {this.state.selectedData!==null &&
            <Grid sx={{ml: 10}}>
              <DialogContentText>วันที่ล่าสุดของข้อมูล {this.state.data.date}</DialogContentText>
              <DialogContentText>ค่าพยากรณ์ระดับน้ำ {this.state.data.predictionWL} ({this.transLevelToMessage(this.state.data.level)})</DialogContentText>
              <DialogContentText>จำนวนวันที่น้ำท่วมในอดีต {this.state.data.flood_count}</DialogContentText>
            </Grid>
          }

          {/* <Divider sx={{pt:2, borderBottomWidth: 1, borderRightWidth: 1}}/> */}
          <Tabs 
            value={this.state.selectedPredictTypeTab}
            onChange={this.handlePredictTypeTabChange}
            centered
          >
            {tabPredictType.map( (tab) => {
                return ( <Tab key={tab.value} value={tab.value} label={tab.label}/> )
                
              })
            }
          </Tabs>
          <Tabs 
            value={this.state.selectedDataTab}
            onChange={this.handleDataTabChange}
            centered
          >
            <Tab value={1} label="ระดับน้ำ"/>
            <Tab value={2} label="น้ำฝน"/>
            <Tab value={3} label="ความชื้นในดิน"/>
            <Tab value={5} label="อุณหภูมิ"/>
          </Tabs>
          <Box>
            {this.state.isLoading===false && this.state.selectedData!==null 
              ? <CustomChart data={this.state.selectedData} options={options}/>
              : <Box alignItems="center" justifyContent="center" sx={{ display: 'flex', mt: 10, mb: 10}}><CircularProgress /></Box>
            }
          </Box>          
          <DownloadContent
            type="area"
            tambon={this.props.selectedArea.tambon}
            amphoe={this.props.selectedArea.amphoe}
            province={this.props.selectedArea.province}  
          />
        </Dialog>
      </Grid>
     
    )
  }

}
export default MapDialog;